import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link ,NavLink,useParams,useNavigate} from "react-router-dom"
import { render } from "react-dom";
import clientconfigwebapp, {
    empty_bk,
    is_phone_hk,
    convert_to_english_strhk,
    scrollTo_uphk,
    show_menu_hh,
    modal_login_reg_bk_show, modal_login_reg_all_hide, redirectbh_typeb, Cart_count_all,
} from '../../clientconfigwebapp';
import { ToastContainer, toast } from 'react-toastify';
import "../../assets/css/sign.css"
import "../../assets/css/signDes.css"
import ReactFullPageLoadinghk from "../../components/layaout/LoadingFullpagehk";
import logo_main from "../../assets/images/logo-web-app.svg";

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Alert from "@mui/material/Alert";

const serialize = require('form-serialize');


const Modal_Login_reg = () => {

    const navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");
    const[phone_mobile,setphone_mobile] = useState('');
    const[phone_mobile_forgot,setphone_mobile_forgot] = useState('');
    const[first_name,setFirst_name] = useState('');
    const[last_name,setLast_name] = useState('');
    const [password,setPassword] = useState('');

    const [show_hide_view_Verification_code,set_show_hide_view_Verification_code] = useState('');
    const [Position_view , setPosition_view] = useState("sign");

    const[phone_mobile_login,set_phone_mobile_login] = useState('');
    const[password_login,set_password_login] = useState('');
    const[page_view_reg_verification_page,set_page_view_reg_verification_page] = useState('reg_verification_page');


    const [reg_verification_code,setRegVerification_code] = useState('');
    const[phone_mobile_login_reg_check,set_phone_mobile_login_reg_check] = useState('');

    const [show_hide_view_Forgot_message,set_show_hide_view_Forgot_message] = useState('');


    useEffect(() => {
        scrollTo_uphk();


       /// localStorage.removeItem("tokenacess");
    }, [1]);





    const Handler_login_show_bk = () => {
        modal_login_reg_bk_show("loginshow");
    };

    const Handle_forgotpassword_show_bk = () => {
        modal_login_reg_bk_show("forgotpassword");
    };

    const Handle_register_show_bk = () => {
        modal_login_reg_bk_show("regloginshow");
    };




    const Handle_login_register_closeall = () => {
        modal_login_reg_all_hide();
    };






    const first_name_Handler=(event)=>{
        setFirst_name(convert_to_english_strhk(event.target.value)); //////document.getElementById("mobileh").scrollIntoView({behavior: 'smooth'});
    }

    const last_name_Handler=(event)=>{
        setLast_name(convert_to_english_strhk(event.target.value));
    }

    const phone_mobile_Handler=(event)=>{
        setphone_mobile(convert_to_english_strhk(event.target.value));
    }

    const password_Handler=(event)=>{
        setPassword(convert_to_english_strhk(event.target.value));
    }








    const password_login_Handler=(event)=>{
        set_password_login(convert_to_english_strhk(event.target.value));
    }


    const phone_mobile_HandlerFocus=(event)=>{

        window.scrollTo(0,0);

    }


    /* forgot pass start   */

    const phone_mobile_Handler_forgot=(event)=>{
        setphone_mobile_forgot(convert_to_english_strhk(event.target.value));
    }

    const validate_form_Forgot=()=> {
        ///console.log(username.toString(),"pppppppppppp");
        /// console.log(is_phone_hk.test(username),"pppppppppppp");

        if (phone_mobile_forgot === '') {
            ///  setErrorMessage('username empty');
            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
            ///} else if (!username.includes('@') || !username.includes('.')) {
        }

        return true;
    }

    const req_send_Handler_Forgot = () => {
///باید قبل return باشه


        const validateResult_forgot =  validate_form_Forgot();

        if(validateResult_forgot){

            let form_data = document.querySelector('#form_Registerpagewebapp');
            if (form_data != null) {

                let data_serialize = serialize(form_data);
                Setloadinghkfullshow("true");
                axios.post(`${clientconfigwebapp.siteurl}api/v1/req-forgot-password/`,data_serialize)
                    .then((res) => {
                        Setloadinghkfullshow("false");
                        /// console.log(res.data, "is 2312das");
                        if (res.data.data=="forgot_ver_page") {


                            modal_login_reg_bk_show("forgot_message_password");
                            ///set_show_hide_view_Forgot_message("show");

                            // dispatch(check_Forgot(true));
                            ////props.history.go("/home");
                            ////props.history.replace('/home');

                        }else {
                            toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            /// alert('errcode:خطا رخ داده کد 421156');
                        }


                        ///localStorage.setItem('token',response.data.Auth.access_token)
                    }).catch((err) =>{
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور اینترنت خود را چک کنید.', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 5431!");

                });



            }else{

                alert('errcode:14');
            }

        }



    }
    /* forgot pass eeend   */






    /*  start login_reg_check_modal   */

    const Handler_phone_login_reg_check=(event)=>{
        set_phone_mobile_login_reg_check(convert_to_english_strhk(event.target.value));
    }

    const HandlerLogin_reg_check_req = () => {


        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }

            let form_data = document.querySelector('#form_Registerpagewebapp');
            if (form_data != null) {
                let data_serialize = serialize(form_data);


                Setloadinghkfullshow("true");

                axios.post(`${clientconfigwebapp.siteurl}api/v1/req-login-reg-check-pr`,data_serialize)
                    .then((res) => {
                        Setloadinghkfullshow("false");

                        if (!empty_bk(res.data.data)) {

                            console.log(res.data.data,"fffffffffffffff");

                            if(String(res.data.data)=="reg_verification_page"){
                                login_verification_page_show("reg_verification_page");
                                modal_login_reg_bk_show("verification_code_reg_show");




                            }
                            if(String(res.data.data)=="login_form_page"){  modal_login_reg_bk_show("loginshow");   }


                        }else {
                            toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        }

                    }).catch((err) =>{
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور کد 5431', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 5431!");

                });



            }else{

                alert('errcode:14');
            }





    }



    /*  enddd login_reg_check_modal   */




    /*  start login_reg_verification_modal   */

    const Handler_Register_login_Verification = () => {



        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }


        if (reg_verification_code === '') {
            toast.error('کد تایید وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }



        let form_data = document.querySelector('#form_Registerpagewebapp');
            if (form_data != null) {
                let data_serialize = serialize(form_data);


                Setloadinghkfullshow("true");
                axios.post(`${clientconfigwebapp.siteurl}api/v1/reg-register-verification/`,data_serialize)
                    .then((res) => {
                        Setloadinghkfullshow("false");

                        if (!empty_bk(res.data.data)) {

                            if(String(res.data.data)=="reg_complate_form_page"){  modal_login_reg_bk_show("regloginshow");   }





                        }else {
                            toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

                        }



                    }).catch((err) =>{
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور کد 5431', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 5431!");

                });



            }else{

                alert('errcode:657567567567');
            }





    }

    const verification_code_reg_Handler=(event)=>{
        setRegVerification_code(convert_to_english_strhk(event.target.value));
    }




    /*  enddd login_reg_verification_modal   */




  /* start register_complate  */

    const Handler_Register_complate = () => {


        if (first_name === '') {
            toast.error('نام درست وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

            /// setErrorMessage('password empty');
            return false;

        }else if (last_name === '') {
            toast.error('نام خانوادگی درست وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

            /// setErrorMessage('password empty');
            return false;

        }else if (phone_mobile_login_reg_check === '') {
            ///  setErrorMessage('username empty');

            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
            ///} else if (!username.includes('@') || !username.includes('.')) {
        }else if (password === '') {
            toast.error('رمز عبور وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

            /// setErrorMessage('password empty');
            return false;

        }



            let form_data = document.querySelector('#form_Registerpagewebapp');
            if (form_data != null) {

                let data_serialize = serialize(form_data);

                Setloadinghkfullshow("true");
                axios.post(`${clientconfigwebapp.siteurl}api/v1/req-register-complate-pr/`,data_serialize)
                    .then((res) => {
                        Setloadinghkfullshow("false");


                        if (!empty_bk(res.data.data)) {

                            localStorage.setItem('tokenacess',res.data.data);
                           if (!empty_bk(res.data.first_name)) {   localStorage.setItem('first_name_Get',res.data.first_name);    }
                            if (!empty_bk(res.data.last_name)) {   localStorage.setItem('last_name_Get',res.data.last_name);    }

                            modal_login_reg_all_hide();
                            var get_url_curent_page = window.location.pathname;

                            if(Cart_count_all() >=1 ){
                                /// console.log(get_url_curent_page,"get_url_curent_page4");
                                redirectbh_typeb(String(clientconfigwebapp.webappurl) + "checkout" );

                            }else{
                                window.location.reload();
                            }
                            // if(String(get_url_curent_page)=="/login" || String(get_url_curent_page)=="/login/" || String(get_url_curent_page)=="/login/"){
                            //     console.log(get_url_curent_page,"get_url_curent_page2");
                            //    redirectbh_typeb(String(clientconfigwebapp.webappurl) + "checkout" );
                            //
                            // }else{
                            //     window.location.reload();
                            // }


                        }else {
                            toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            /// alert('errcode:خطا رخ داده کد 421156');
                        }


                    }).catch((err) =>{
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور کد 456456', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 5431!");

                });



            }else{

                alert('errcode:14');
            }





    }

   /* endddd register_complate  */



    /* start login_by_pasword_complate  */

    const Handler_Login_req = () => {

        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }else if (password_login === '') {
            toast.error('رمز عبور وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;

        }

            let form_data = document.querySelector('#form_Registerpagewebapp');
            if (form_data != null) {
                let data_serialize = serialize(form_data);


                Setloadinghkfullshow("true");


                axios.post(`${clientconfigwebapp.siteurl}api/v1/req-login-pr`,data_serialize)
                    .then((res) => {

                        Setloadinghkfullshow("false");

                        if (!empty_bk(res.data.data)) {

                            localStorage.setItem('tokenacess',res.data.data);
                            if (!empty_bk(res.data.first_name)) {   localStorage.setItem('first_name_Get',res.data.first_name);    }
                            if (!empty_bk(res.data.last_name)) {   localStorage.setItem('last_name_Get',res.data.last_name);    }

                            modal_login_reg_all_hide();
                            var get_url_curent_page = window.location.pathname;

                            if(Cart_count_all() >=1 ){
                                /// console.log(get_url_curent_page,"get_url_curent_page4");
                                redirectbh_typeb(String(clientconfigwebapp.webappurl) + "checkout" );

                            }else{
                                window.location.reload();
                            }

                            // if(String(get_url_curent_page)=="/login" || String(get_url_curent_page)=="/login/" || String(get_url_curent_page)=="/login/"){
                            //     console.log(get_url_curent_page,"get_url_curent_page3");
                            //     redirectbh_typeb(String(clientconfigwebapp.webappurl) + "checkout" );
                            //
                            // }else{
                            //     window.location.reload();
                            // }



                        }else{
                            toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                            /// alert('errcode:خطا رخ داده کد 421156');
                        }

                    }).catch((err) =>{
                    Setloadinghkfullshow("false");
                    toast.error('خطای اتصال به سرور کد 5431', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    console.error(err, "is error 5431!");

                });



            }else{

                alert('errcode:14');
            }





    }

    /* enddd login_by_password_complate  */



/* start login_by_sms_code  */

    const login_verification_page_show=(valueget)=>{
        setRegVerification_code("");

if(String(valueget)=="reg_verification_page"){  set_page_view_reg_verification_page("reg_verification_page");  }
if(String(valueget)=="login_verification_page"){  set_page_view_reg_verification_page("login_verification_page");  }

       /// reg_verification_page
       /// login_verification_page
        /////valueget
    }

    const Handle_req_login_send_code_sms = () => {


        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }

        let form_data = document.querySelector('#form_Registerpagewebapp');
        if (form_data != null) {
            let data_serialize = serialize(form_data);


            Setloadinghkfullshow("true");

            axios.post(`${clientconfigwebapp.siteurl}api/v1/login-by-code-sms-pr`,data_serialize)
                .then((res) => {
                    Setloadinghkfullshow("false");

                    if (!empty_bk(res.data.data)) {

                        console.log(res.data.data,"fffffffffffffff");

                        if(String(res.data.data)=="login_verification_page"){

                            login_verification_page_show("login_verification_page");
                            modal_login_reg_bk_show("verification_code_reg_show");


                        }
                        if(String(res.data.data)=="login_form_page"){  modal_login_reg_bk_show("loginshow");   }


                    }else {
                        toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                    }

                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 5431', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                console.error(err, "is error 5431!");

            });



        }else{

            alert('errcode:14');
        }
        /////modal_login_reg_bk_show("regloginshow");
    };




    const Handler_req_login_code_sms_Verification = () => {



        if (phone_mobile_login_reg_check === '') {
            toast.error('شماره موبایل وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }


        if (reg_verification_code === '') {
            toast.error('کد تایید وارد نشده', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
            return false;
        }



        let form_data = document.querySelector('#form_Registerpagewebapp');
        if (form_data != null) {
            let data_serialize = serialize(form_data);


            Setloadinghkfullshow("true");
            axios.post(`${clientconfigwebapp.siteurl}api/v1/req_login_code_verification-pr/`,data_serialize)
                .then((res) => {
                    Setloadinghkfullshow("false");

                    if (!empty_bk(res.data.data)) {

                        localStorage.setItem('tokenacess',res.data.data);
                        if (!empty_bk(res.data.first_name)) {   localStorage.setItem('first_name_Get',res.data.first_name);    }
                        if (!empty_bk(res.data.last_name)) {   localStorage.setItem('last_name_Get',res.data.last_name);    }

                        modal_login_reg_all_hide();
                        var get_url_curent_page = window.location.pathname;

                      /// console.log(get_url_curent_page,"get_url_curent_page1");

                       // if(String(get_url_curent_page)=="/login" || String(get_url_curent_page)=="/login/" || String(get_url_curent_page)=="/login/"){

                        if(Cart_count_all() >=1 ){
                           /// console.log(get_url_curent_page,"get_url_curent_page4");
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "checkout" );

                        }else{
                            window.location.reload();
                        }


                    }else {
                        toast.error(res.data.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                        /// alert('errcode:خطا رخ داده کد 421156');
                    }



                }).catch((err) =>{
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 5431', {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
                console.error(err, "is error 5431!");

            });



        }else{

            alert('errcode:657567567567');
        }





    }



    /* ennnndddd login_by_sms_code  */


    return (
        <Fragment>
            <div className="fullbox_reg_login modal_animation_bk_2"  id={"login_reg_view_modal"} style={{"display":"none"}}>

                <div className={"modal-bg-bk"}  onClick={ Handle_login_register_closeall }   ></div>

                <div className="fullbox_reg_login_main">
                    <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                    <ToastContainer/>
                    <section className="flexColStartCenter sign-container">


<span className={"close-btn-modal-reglogin"} onClick={Handle_login_register_closeall} style={{color: "black", position: "absolute", left: 49, top: 35, fontSize: 23}}>X</span>


                        <form id="form_Registerpagewebapp">

                            <section style={(() => {
                                if (show_hide_view_Verification_code == "show") {
                                    return ({display: "none"})
                                } else {
                                    return ({display: "block"})
                                }
                            })()}>


                              <div className={"logo_reg_login_modal"} style={{"textAlign":"center"}}>  <img src={logo_main}   /></div>





                                <div id="login_reg_check_view_modal" className="flexColStartStart" style={{"display":"block"}}>
                                    <span style={{"display":"block","textAlign":"center","paddingTop":"8px","paddingBottom":"20px","color":"black","fontWeight":"bold"}}>ورود یا عضویت</span>

                                    <div className="box-input-formreg-login">
                                        <label>شماره موبایل</label>
                                        <input type="text" name="phone_mobile" onChange={Handler_phone_login_reg_check} style={{"direction": "ltr"}}/>
                                    </div>



                                    <button type="button" onClick={HandlerLogin_reg_check_req}  style={{"width": "100%", "marginBottom": "16px"}}  className="btn-bh btn-black-bh">
                                        ادامه
                                    </button>



                                </div>





                                <div id="verification_code_reg_view_modal" className="flexColStartStart" style={{"display":"none"}}>

                                    <span style={{"display":"block","textAlign":"center","paddingTop":"8px","paddingBottom":"20px","color":"black","fontWeight":"bold"}}>تایید پیامکی</span>

                                    <div className="box-input-formreg-login">
                                        <label>کد پیامک شده را وارد کنید</label>
                                        <input style={{textAlign:"center"}} onChange={verification_code_reg_Handler} type="text" name="verification_code"/>
                                    </div>





                                    {  page_view_reg_verification_page=="login_verification_page" ?  (<Fragment><button type="button" onClick={Handler_req_login_code_sms_Verification} style={{"width": "100%", "marginBottom": "16px"}} className="btn-bh  btn-black-bh">تایید کد</button></Fragment> ) : (<Fragment><button type="button" onClick={Handler_Register_login_Verification} style={{"width": "100%", "marginBottom": "16px"}} className="btn-bh  btn-black-bh">ادامه</button></Fragment>)   }








                                </div>








                                <div id="register_view_modal" className="flexColStartStart" style={{"display":"none"}}>

                                    <div>

                                        <div className="box-input-formreg-login">
                                            <label>نام</label>
                                            <input onChange={first_name_Handler} type="text" name="first_name"/>
                                        </div>


                                        <div className="box-input-formreg-login">
                                            <label>نام خانوادگی</label>
                                            <input onChange={last_name_Handler} type="text" name="last_name"/>
                                        </div>

                                        <div className="box-input-formreg-login">
                                            <label>رمز عبور</label>
                                            <input onChange={password_Handler} type="password" name="password" style={{"direction": "ltr"}}/>
                                        </div>



                                        <button type="button" onClick={Handler_Register_complate} style={{"width": "100%", "marginBottom": "16px"}} className="btn-bh btn-black-bh">
                                            تکمیل ثبت نام
                                        </button>

                                    </div>

                                </div>










                                <div id="login_view_modal" className="flexColStartStart" style={{"display":"none"}}>



                                    <div className="box-input-formreg-login">
                                        <label>
                                            <div style={{ display: "flex",  justifyContent: "space-between",  alignItems: "center",  width: "100%",  flexDirection: "row",  flexWrap: "nowrap"}}>
                                                <span style={{ display: "block" }}>رمز عبور</span>
                                                <span onClick={Handle_req_login_send_code_sms} style={{ display: "block", color: "#559800" }}>ورود با رمز یکبارمصرف</span>
                                            </div>
                                        </label>
                                        <input type="password" name="password_login" onChange={password_login_Handler} style={{"direction": "ltr"}}/>
                                    </div>




<div style={{ textAlign: "right",marginBottom:"10px" }}>
    <span onClick={Handle_req_login_send_code_sms} style={{ color: "rgb(98,98,98)",fontSize: 12, paddingLeft: 10, fontFamily: '"iran"' }}>رمز عبور خود را فراموش کرده اید؟</span>
<span onClick={Handle_req_login_send_code_sms} style={{fontSize: 12, paddingLeft: 10, color: "rgb(0,0,0)", cursor: "pointer", fontFamily: '"iran"'}}>بازیابی رمز عبور</span>
</div>






                                    <button type="button" onClick={Handler_Login_req}  style={{"width": "100%", "marginBottom": "16px"}}  className="btn-bh btn-black-bh">
                                        ورود
                                    </button>



                                </div>







                                <div id="forgot_view_modal" className="flexColStartStart" style={{"display":"none"}}>

                                    <div>
                                        <label>
                                            <input onChange={phone_mobile_Handler_forgot} type="text" name="phone_mobile_login_forgot"  style={{"direction":"ltr"}} />
                                            <span>شماره موبایل</span>
                                        </label>


                                        <button onClick={req_send_Handler_Forgot} type="button"  style={{"width": "100%", "marginBottom": "16px"}} className="btn-bh btn-orange-bh">
                                            ادامه
                                        </button>

                                    </div>

                                </div>


                                <div id="forgot_message_view_modal" className="flexColStartStart" style={{"display":"none"}}>







<div style={{width: "100%", textAlign: "center", backgroundColor: "#ffeb3b38", borderRadius: 18, paddingBottom: 1, marginBottom: 20}}>


                                    <img style={{"width":"100px","marginTop":"38px"}} src={ clientconfigwebapp.webappurl + "images/6711888.png"}  />
                                        <div style={{"display":"block","fontSize":"15px","fontFamily":"iranyekan","marginBottom":"31px","marginTop":"18px"}}>

                                            <span style={{"fontSize":"12px","fontWeight":"normal","fontFamily":"'iran'","paddingTop":"10px","position":"relative","top":"2px","paddingRight":"3px"}}>رمز عبور جدید برای شما پیامک شد،از طریق صفحه لاگین وارد شوید.</span>



<div style={{ textAlign: "center", display: "flex", justifyContent: "center" }}>
<span className={"login_btn_forgot"} onClick={Handler_login_show_bk} style={{fontFamily: "iran", fontSize: 14, paddingTop: 18, display: "block", border: "solid", width: "48%", paddingBottom: 15, marginTop: 27, borderRadius: 10}}>
صفحه لاگین
</span>
 </div>



                                        </div>


                                    </div>


                                </div>





                            </section>








                        </form>




                    </section>

                </div>
            </div>

        </Fragment>
    );
}


export default Modal_Login_reg;